var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('isHeader',{ref:"isHeader"}),_c('div',{ref:"scrollBox",staticStyle:{"height":"100vh","overflow-y":"auto","overflow-x":"hidden"}},[_c('commonTop',{attrs:{"info":{
              title:'招贤纳士',
              desc:'我们求贤若渴，期待您的加入！',
              show_desc:true
          },"img":require('@/assets/recruit/banner.png')}},[_c('div')]),_c('isCom'),_c('isFooter')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }